var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticStyle:{"padding":"20px"}},[_vm._v(" Scan Tags Continuously Using Phone App ")]),_c('p',[_c('v-btn',{attrs:{"color":"blue"},on:{"click":_vm.requestScan}},[_vm._v("Scan Using Mobile App")])],1),_c('p',[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }